// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__26vft","notes":"Notes_notes__2Lq0O"};